module.exports = __webpack_public_path__ + "static/media/shopping-bag.ca800f78.png";